import React from "react"
import { BrowserRouter as Router } from "react-router-dom"
import ReactDOM from "react-dom/client"
import "./index.css"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import Root from "./root"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import store from "redux/store"
import Modal from "components/Modal"
import "./i18n"
import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from "react-toastify"
window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty("--vh", `${vh}px`)
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <Router>
      <Root />
      <ToastContainer />
      <Modal />
    </Router>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
